import { Panel } from '@assets/component/Panel/Panel';
import * as style from './DealFlowiseChat.module.less';
import steps_icon from './steps_icon.svg';
import refresh_icon from './refresh_icon.svg';

import { Split } from '@assets/component/Split/Split';
import { Flex } from '@assets/component/UI/Flex/Flex';
import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import { useStore } from '@assets/model/Store';
import { useConfig } from '@assets/model/StoreConfig';
import Chatbot from 'flowise-embed/dist/web.js';
//import Chatbot from './dist/web.js';
import { observer } from 'mobx-react';
import { report } from 'process';
import { Fragment, useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import useMeasure from 'react-use-measure';
import { throttle } from 'lodash';
import { get, onValue, ref, set } from 'firebase/database';
import { LoadingAnimation } from '@assets/component/LoadingAnimation/LoadingAnimation';
import _ from 'lodash';

interface FlowChatStep {
    step_id: string;
    name: string;
    flow_id: string;
    start_message: string;
    include_variables?: boolean;
    show_checkmark_if_var_exists?: string;
}

const StepsConfig: FlowChatStep[] = [
    {
        step_id: 'step1',
        name: 'Generate Competitive Landscape',
        flow_id: 'cb6c7935-192b-4759-959e-a1d80c300566',
        start_message:
            'Please enter information about the company you want to research - Company Name, website, and any relevant details?',
        show_checkmark_if_var_exists: 'COMPETITIVE_LANDSCAPE'
    },
    {
        include_variables: true,
        step_id: 'step3',
        name: 'Generate Expert Interview Guide',
        flow_id: '56b08a1c-53d3-441d-97e8-591b99886e0d',
        start_message: 'Generate Expert Interview Guide.'
    },
    {
        include_variables: true,
        step_id: 'step2',
        name: 'Enhance with Documents',
        flow_id: 'd010ae95-e06a-4cae-a112-1914e795930a',
        start_message:
            'Please upload any relevant documents that can help us with the research.'
    }
];

const DEV_StepsConfig: FlowChatStep[] = [
    {
        step_id: 'test_save_myvar',
        name: 'Save Variable Test',
        flow_id: 'be691fb5-e36c-4e54-984b-7758b737433c',
        start_message: 'What value do you want to save?',
        show_checkmark_if_var_exists: 'MY_VAR'
    },
    {
        step_id: 'test_myvar',
        name: 'Test MY_VAR with config-overide',
        flow_id: '542d1ecc-90ee-412d-917f-357ddba48f23',
        start_message: 'Test if MY_VAR passes'
    },
    {
        step_id: 'competitive_landscape',
        name: 'Competitive landscape GPT4 DEV',
        flow_id: 'd28ed001-bac9-4b22-a7e4-9730d57bbb7d',
        start_message: 'Please input the company details for analysis.',
        show_checkmark_if_var_exists: 'COMPETITIVE_LANDSCAPE'
    },
    {
        step_id: 'document_analysis',
        name: 'Add Research Analysis DEV',
        flow_id: 'fec4baca-35ce-4f53-9ed6-2ff8a88a1af6',
        start_message: 'Please upload relevant documents for analysis.',
        include_variables: true
    },
    {
        step_id: 'short_story_test',
        name: 'Short story',
        flow_id: '93741131-fe09-44b2-b3cc-dcb113e290d4',
        start_message: 'Short story.',
        include_variables: true
    }
];

export const DealFlowiseChat = observer(() => {
    const store = useStore();
    const doNotDeleteSessionUntil = useRef(0);

    const [activeFlowIndex, setActiveFlowIndex] = useState(0);
    const [varList, setVarList] = useState<string[]>([]);
    const [flowToSessionId, setSessionsList] = useState<{
        [key: string]: string;
    }>({});

    const [didSessionsLoads, setDidSessionsLoads] = useState(false);

    const chatRef = useRef<HTMLDivElement>(null);
    const [elRef, bounds] = useMeasure();
    const [showLoading, setShowLoading] = useState(true);

    const config = useConfig();
    const flowise_url = config.flowise_url || 'http://localhost:3000';

    const save_run_state = async (
        flowId: string,
        reportId: string,
        state: any
    ) => {
        const fbKey = `flowise_run_state/${reportId}/${flowId}`;
        const r = ref(getFirebase().db, fbKey);
        await set(r, state);
    };

    const restore_run_state_from_flowise = async (
        flowId: string,
        reportId: string
    ) => {
        const sessionId = flowToSessionId[flowId] ?? null;
        if (!sessionId) return;
        const bearer =
            config.flowise_api_key ||
            'uKyxi0aW1GqYoRw_Y48F3YaNsbmDMa-7d8eyE9oloic';
        const api = `${flowise_url}/api/v1/chatmessage/${flowId}?sessionId=${sessionId}`;
        const resp = fetch(api, {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + bearer
            }
        });

        const data = await (await resp).json();
        const messages: any[] = data;
        if (!messages || messages.length == 0) return;

        const messages_mapped = messages.map(msg => {
            return {
                type: msg.role,
                message: msg.content,
                fileUploads: msg.fileUploads || [],
                action: msg.action || null,
                agentFlowEventStatus: msg.state || null
            };
        });

        const file_contents = {
            chatHistory: messages_mapped,
            chatId: sessionId
        };

        const localStorageKey = genLocalStorageKey(flowId);

        localStorage.setItem(localStorageKey, JSON.stringify(file_contents));
        console.log(
            'Restored run state from Flowise for flowId: ',
            flowId,
            localStorageKey,
            file_contents
        );
    };

    const genLocalStorageKey = (flowId: string) => {
        return `${flowId}_EXTERNAL`; //This is how flow-wise saves STATE
    };

    const saveMessagesThrottled = throttle((flowId, messages: string[]) => {
        //Moved reset to our own button to avoid weirdness of loading issues
        // if (messages.length == 1) {
        //     //Do nothing, if they clear and refresh they got old one

        //     if (Date.now() < doNotDeleteSessionUntil.current) {
        //         console.log('--- Not deleting session ID for flowId: ', flowId);
        //         return;
        //     }

        //     //This can happen when a new flow is loaded or we clicked CLEAR
        //     console.log('** Deleting session ID for flowId: ', flowId);
        //     delete_flow_assosiated_session_id(flowId);
        //     return;
        // }

        if (messages.length > 1) {
            //This means this already has a session ->
            //We can now read from the local Storage and fetch the chatId and store it

            const localStorageKey = genLocalStorageKey(flowId);
            const localStorageData = localStorage.getItem(localStorageKey);
            if (localStorageData) {
                const localStorageJson = JSON.parse(localStorageData);
                const chatId = localStorageJson['chatId'] ?? null;

                const realtimeSessionId = flowToSessionId[flowId] ?? null;
                if (realtimeSessionId && realtimeSessionId != chatId) {
                    console.log(
                        '###### This should not happen -> We already have a session ID?'
                    );
                    console.log('In Realtime: ', realtimeSessionId, chatId);
                    return;
                } else {
                    if (chatId) {
                        if (realtimeSessionId === chatId) {
                            console.log(
                                '--- Session ID already saved for flowId: ',
                                flowId
                            );
                            return;
                        }

                        const path = `flowise_sessions/${store.selectedReportId}/${flowId}`;
                        const r = ref(getFirebase().db, path);
                        set(r, chatId);
                        console.log(
                            '--- Saving new session ID for flowId: ',
                            flowId,
                            chatId
                        );
                    }
                }
            }
        }
    }, 250);

    const delete_flow_associated_session_id = async (flowId: string) => {
        const path = `flowise_sessions/${store.selectedReportId}/${flowId}`;
        const r = ref(getFirebase().db, path);
        await set(r, null);
    };

    const onClickResetFlow = async () => {
        const flow = FLOWS_LIST[activeFlowIndex];
        const flowId = flow.flow_id;
        console.log('Deleting flow session for flowId: ', flowId);
        await delete_flow_associated_session_id(flowId);
        location.reload();
    };

    useEffect(() => {
        const path = `flowise_sessions/${store.selectedReportId}`;
        const r = ref(getFirebase().db, path);
        const unsub = onValue(r, snapshot => {
            const data = snapshot.val() || {};
            setSessionsList(data);
            setDidSessionsLoads(true);
        });
        return () => unsub();
    }, []);

    useEffect(() => {
        const path = `flowise_vars/${store.selectedReportId}`;
        const r = ref(getFirebase().db, path);
        const unsub = onValue(r, snapshot => {
            const data = snapshot.val() || {};
            const keys = Object.keys(data).sort();
            setVarList(keys);
        });
        return () => unsub();
    }, []);

    const useDev = store.isDev && false;

    const FLOWS_LIST = !useDev ? StepsConfig : DEV_StepsConfig;

    const StepElement = (flow_index: number) => {
        const { name } = FLOWS_LIST[flow_index];
        var check_opacity = 0;

        const flow = FLOWS_LIST[flow_index];
        if (flow.show_checkmark_if_var_exists) {
            if (varList.indexOf(flow.show_checkmark_if_var_exists) >= 0) {
                check_opacity = 1;
            }
        }

        return (
            <Fragment key={'flow-step-' + flow_index}>
                <Flex
                    key={'flow-step-' + flow_index}
                    alignItems="center"
                    justify="start"
                    style={{
                        width: '95%',
                        height: '75px',
                        border: '1.5px solid #405474ff',
                        borderRadius: '17px',
                        backgroundColor: '#f6f6f6ff',
                        marginLeft: '20px',
                        filter: 'drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.5))'
                    }}
                >
                    <div className={style.step_index}>{flow_index + 1}.</div>
                    <div className={style.step_title}>{name}</div>
                    <i
                        className="bi bi-check-lg"
                        style={{
                            paddingTop: '-3px',
                            marginRight: '10px',
                            fontSize: '30px',
                            color: '#4BB543',
                            filter: 'drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25))',
                            transition: 'opacity 0.75s ease-in-out',
                            marginLeft: '15px',
                            opacity: check_opacity
                        }}
                    ></i>
                    <div style={{ flex: 1 }}></div>
                    <Button
                        variant="light"
                        onClick={() => setActiveFlowIndex(flow_index)}
                        style={{
                            right: '20px',
                            height: '40px',
                            marginRight: '10px'
                        }}
                    >
                        View
                    </Button>
                </Flex>
                <div
                    style={{
                        borderBottom: '1px dashed #d0d5dd',
                        width: '100%',
                        height: '2px',
                        margin: '5px'
                    }}
                ></div>
            </Fragment>
        );
    };

    const init_chat_fn = () => {
        Chatbot.destroy();

        const reportId = useStore().selectedReportId;
        const flow = FLOWS_LIST[activeFlowIndex];
        const flow_id = `${flow.flow_id}`;

        const delete_all_storage_keys = () => {
            const keys = Object.keys(localStorage);
            for (const key of keys) {
                if (key.indexOf('_EXTERNAL') >= 0) {
                    console.log('Deleting localStorage key: ', key);
                    localStorage.removeItem(key);
                }
            }
        };

        const onProcessSaveMessage = (messageObj: any) => {
            if (messageObj.type != 'apiMessage') return;
            //if (messageObj.agentFlowEventStatus != 'FINISHED') return;

            const message = messageObj?.message || '';
            console.log('Last message received: ', message);
            const SAVE_VAR_PREFIX = '\\-- Saving Variable:';
            if (message.indexOf(SAVE_VAR_PREFIX) >= 0) {
                const start = message.split(SAVE_VAR_PREFIX)[1].split('\n')[0];
                const varName = start.trim();
                console.log('Saving variable: ', varName);
                const valueToSave = message
                    .split(SAVE_VAR_PREFIX)[1]
                    .split('\n')
                    .slice(1)
                    .join('\n');
                console.log('Save Value: ', valueToSave);

                const fb = getFirebase();
                fb.save_flowise_variable(reportId, varName, valueToSave);
            }
            // You can add custom logic here to process the last message
        };

        const init_chat_internal = async () => {
            setShowLoading(true);
            delete_all_storage_keys();
            await restore_run_state_from_flowise(flow_id, reportId);
            doNotDeleteSessionUntil.current = Date.now() + 2000;

            const start_message = flow.start_message;
            var chat_vars = {};

            var chatFlowConf = {
                //chatId: '123',
                vars: {
                    //customerId: '123'
                }
            };

            if (flow.include_variables) {
                chat_vars = await getFirebase().get_all_flowise_vars(reportId);
                chatFlowConf['state'] = chat_vars;
                console.log('Including chat variables: ', chat_vars);
            }

            const config = {
                chatflowid: flow_id,
                apiHost: flowise_url,
                theme: {
                    chatWindow: {
                        titleBackgroundColor: '#304970ff',
                        backgroundColor: '#F9FAFB',
                        height: bounds.height + 70,
                        welcomeMessage: start_message,
                        userMessage: {
                            backgroundColor: '#304970ff'
                        },
                        footer: {
                            textColor: '',
                            text: '',
                            company: '',
                            companyLink: ''
                        }
                    }
                },
                chatflowConfig: chatFlowConf,
                observersConfig: {
                    observeUserInput: userInput => {
                        //console.log({ userInput });
                    },

                    observeMessages: (messages: []) => {
                        //console.log(messages);
                        if (!messages) return;

                        onProcessSaveMessage(messages[messages.length - 1]);
                        saveMessagesThrottled(flow_id, messages);
                    },
                    // The bot loading signal changed
                    observeLoading: loading => {
                        //console.log({ loading });
                    }
                }
            };

            setShowLoading(false);
            Chatbot.initFull(config);
        };

        init_chat_internal();
    };

    useEffect(() => {
        if (bounds.height < 100) return;

        if (!didSessionsLoads) return;

        init_chat_fn();

        return () => {
            Chatbot.destroy();
        };
    }, [bounds.height, activeFlowIndex, didSessionsLoads]);
    return (
        <Split layoutPercent={[30, 70]}>
            <Panel fillCell={true}>
                <Flex
                    style={{
                        width: '100%',
                        top: '-15px',
                        position: 'absolute',
                        zIndex: 10000
                    }}
                    direction="column"
                    wrap={'wrap'}
                >
                    <div
                        className={style.steps_title}
                        style={{
                            backgroundColor: '#304970',
                            width: '100%',
                            height: '50px'
                        }}
                    >
                        <Flex>
                            <img
                                src={steps_icon}
                                style={{
                                    height: '30px',
                                    marginRight: '8px',
                                    transform: 'scale(1.0)'
                                }}
                            />
                            <span style={{ position: 'relative', top: '-1px' }}>
                                Research Steps
                            </span>
                        </Flex>
                    </div>
                    <Flex
                        fillCell={true}
                        wrap={'wrap'}
                        style={{ paddingTop: '20px', rowGap: '10px' }}
                    >
                        {FLOWS_LIST.map((step, index) => StepElement(index))}
                    </Flex>
                </Flex>
            </Panel>
            <Panel fillCell={true} className={style.flowiseView}>
                <div className={style.refreshButton}>
                    <img
                        src={refresh_icon}
                        alt="Refresh"
                        onClick={() => onClickResetFlow()}
                    />
                </div>
                <div
                    className="fade-in"
                    key="animation"
                    style={{
                        paddingTop: '100px',
                        left: '30%',
                        opacity: showLoading ? 1 : 0,
                        position: 'absolute'
                    }}
                >
                    <LoadingAnimation width={400} height={200} />
                </div>

                <div
                    ref={elRef}
                    style={{ width: '100%', height: '100%' }}
                ></div>
            </Panel>
        </Split>
    );
});
